import React from "react";
import "./StatRepIntAna.css";
import PageHeader from "../../../components/headers/PageHeader";
import wave from "../../../assets/Images/waves/wave_mou.png";

export default function StatRepIntAna() {
    return (
        <div className="statrep-page">
            <PageHeader
                mediaSrc={wave}
                mediaType="image"
                subtitle="Statistical Reporting & Regulatory Insight"
                title="Statistical Reporting & Integrated Analyses"
            />

            <section className="statrep-section statrep-introSection">
                <h2>Integrated Statistical Support for Regulatory Submissions</h2>

                <p>
                    Our CDISC and regulatory submission services encompass the complete
                    data lifecycle — from CDASH design and SDTM/ADaM development through
                    Define-XML, Reviewer Guides, TLFs, ISS/ISE analyses, eCTD submission
                    support, and regulatory-ready documentation.
                </p>

                <p>
                    Eupraxia helps sponsors accelerate submissions while maintaining the
                    highest standards of quality, compliance, traceability, and regulatory
                    inspection readiness.
                </p>
            </section>

            <section className="statrep-section statrep-cardSection">
                <h2>Statistical Reporting & Integrated Analyses</h2>

                <div className="statrep-cardGrid">
                    <article className="statrep-card">
                        <h3>Tables, Listings, and Figures</h3>
                        <span className="statrep-cardSubtitle">TLFs</span>

                        <p>
                            Generation of submission-quality outputs supporting Clinical
                            Study Reports and regulatory review.
                        </p>
                    </article>

                    <article className="statrep-card">
                        <h3>Integrated Summary of Safety</h3>
                        <span className="statrep-cardSubtitle">ISS</span>

                        <p>
                            Cross-study integration of safety data to evaluate adverse
                            events, laboratory findings, exposure, and the overall safety
                            profile across the development program.
                        </p>
                    </article>

                    <article className="statrep-card">
                        <h3>Integrated Summary of Efficacy</h3>
                        <span className="statrep-cardSubtitle">ISE</span>

                        <p>
                            Pooled efficacy analyses across multiple studies to support
                            demonstration of treatment benefit and consistency of effect.
                        </p>
                    </article>

                    <article className="statrep-card">
                        <h3>Submission-Ready Statistical Analysis Packages</h3>

                        <p>
                            Statistical programming, traceability documentation, validation,
                            and regulatory-quality outputs supporting NDA, BLA, MAA, and
                            other submissions.
                        </p>
                    </article>

                    <article className="statrep-card">
                        <h3>Meta-Analysis and Evidence Synthesis</h3>

                        <p>
                            Cross-study quantitative analyses to support benefit-risk
                            evaluations, regulatory interactions, and strategic
                            decision-making.
                        </p>
                    </article>
                </div>
            </section>

            <section className="statrep-section statrep-supportSection">
                <h2>Regulatory Submission Support</h2>

                <div className="statrep-supportGrid">
                    <article className="statrep-supportCard">
                        <h3>eCTD Submission Components</h3>

                        <p>
                            Preparation of data deliverables and supporting documentation
                            for inclusion within electronic Common Technical Document
                            submissions.
                        </p>
                    </article>

                    <article className="statrep-supportCard">
                        <h3>Data Traceability and Audit Readiness</h3>

                        <p>
                            End-to-end traceability from source data through SDTM, ADaM,
                            TLFs, and CSR outputs, supporting inspection readiness and
                            regulatory transparency.
                        </p>
                    </article>

                    <article className="statrep-supportCard">
                        <h3>Legacy Data Conversion &amp; Dictionary Up-versioning</h3>

                        <p>
                            Migration and standardization of historical clinical data into
                            current CDISC standards to support pooled analyses and new
                            regulatory submissions.
                        </p>
                    </article>

                    <article className="statrep-supportCard">
                        <h3>Submission Gap Assessments</h3>

                        <p>
                            Evaluation of existing studies against current regulatory and
                            CDISC requirements, with remediation strategies for successful
                            submissions.
                        </p>
                    </article>
                </div>
            </section>

            <section className="statrep-section statrep-specializedSection">
                <h2>Specialized Data Services</h2>

                <p className="statrep-sectionIntro">
                    We support specialized statistical and data standardization needs
                    across clinical development, regulatory review, and evidence
                    generation programs.
                </p>

                <div className="statrep-specializedGrid">
                    <article className="statrep-specializedCard">
                        <h3>PK and PD Data Standardization</h3>

                        <p>
                            Preparation of pharmacokinetic and pharmacodynamic datasets,
                            concentration-time analyses, exposure-response datasets, and
                            integrated analyses.
                        </p>
                    </article>

                    <article className="statrep-specializedCard">
                        <h3>Real-World Data and Registry Data Standardization</h3>

                        <p>
                            Transformation of observational and real-world datasets into
                            standardized structures for regulatory use.
                        </p>
                    </article>

                    <article className="statrep-specializedCard">
                        <h3>Safety Signal Detection and Benefit-Risk Analyses</h3>

                        <p>
                            Advanced statistical analyses supporting regulatory safety
                            evaluations and risk management activities.
                        </p>
                    </article>
                </div>
            </section>
        </div>
    );
}